import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const EMERGENCY_CALLS_QUEUE_EVENT_NAMES = {
  CLICK_CALL_FROM_QUEUE: 'click_on_call_from_queue',
  CLICK_CALL: 'calls_clicked_on',
  REMOVE_CALL: 'removed_a_number',
  TT911_REQUEST: 'text_to_911_added_to_queue',
};

export const trackClickCallFromQueue = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackEvent({
    name: EMERGENCY_CALLS_QUEUE_EVENT_NAMES.CLICK_CALL_FROM_QUEUE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Click on Call From Queue',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
      isSXMCrashed: isConnectedCar,
      portalType,
      serviceType,
      classOfServices,
      callStatus: callStatus || '',
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};

export const trackClickCall = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  serviceType,
  classOfServices,
  callStatus,
) => {
  gspx.trackEvent({
    name: EMERGENCY_CALLS_QUEUE_EVENT_NAMES.CLICK_CALL,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Calls Clicked On',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
      isSXMCrashed: isConnectedCar,
      portalType,
      serviceType,
      classOfServices,
      callStatus: callStatus || '',
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};

export const trackRemoveCall = (
  isConnectedCar = false,
  irpVersion,
  payloadID,
  requestID,
  portalType,
  callStatus,
) => {
  gspx.trackEvent({
    name: EMERGENCY_CALLS_QUEUE_EVENT_NAMES.REMOVE_CALL,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Removed a number',
      Category: 'Google Map',
      'Launched date': new Date(),
      irpVersion,
      isSXMCrashed: isConnectedCar,
      portalType,
      callStatus: callStatus || '',
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};

export const trackTT911Request = (irpVersion, payloadID, requestID) => {
  gspx.trackEvent({
    name: EMERGENCY_CALLS_QUEUE_EVENT_NAMES.TT911_REQUEST,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data CallQueueList',
      legacy_name: 'Text-to-911 added to queue',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};
